type InlineSpinnerProps = {
  /** Accessible label; defaults to "Loading". */
  label?: string
  className?: string
}

/** Small neutral spinner for inline loading next to labels (not on primary buttons). */
export function InlineSpinner({ label = 'Loading', className }: InlineSpinnerProps) {
  return (
    <span
      className={['inline-spinner', className].filter(Boolean).join(' ')}
      role="status"
      aria-label={label}
    />
  )
}
